/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon32Regular = forwardRef('ArrowShapeADownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.527 28.44a3.5 3.5 0 0 0 4.95 0l11.025-11.027c1.26-1.26.368-3.414-1.414-3.414H23V6a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v7.999H3.916c-1.782 0-2.675 2.154-1.415 3.414L13.527 28.44Zm3.536-1.415a1.5 1.5 0 0 1-2.121 0L3.915 15.999H10a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8.999a1 1 0 0 0 1 1h6.088L17.063 27.025Z" })));
});
